<app-loading></app-loading>
<section [style.background]="'linear-gradient(90deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.6) 50%, rgba(0,0,0,0.4) 100%), url(' + carouselContent[currentImageIndex].image + ')'"
        [style.backgroundSize]="'cover'"
        [style.backgroundPosition]="'center'"
        [style.height]="'100vh'"
        [style.transition]="'background 1s ease-in-out'"
        class="hero-section">
    <div class="header-section container">
        <div class="logo-sec">
            <a [routerLink]="['/']" style="font-size: 40px;color: white;font-weight: bold;">
                <!-- <img src="assets/images/icon/logo.png" alt="logo" class="img-fluid"> -->
                 YokaStar
            </a>
        </div>
        <a [routerLink]="['/explore']" class="explore-btn text-white" style="position: absolute !important;
        right: 150px;
        top: 30px;">
            Explorez
        </a>
    </div>
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                
                <div style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 75%; height: 75%;">
                    <video [src]="video.file_url" class="video-preview img-cover" autoplay controls muted playsinline></video>   
                </div>
            </div>
        </div>
</section>